import { palette, setColor } from 'app_previous/styles/colors';
import styled from 'styled-components';

export interface CaptionSpanProps {
  captionColor?: 'white' | 'black';
}

export const CaptionSpan = styled.span<CaptionSpanProps>`
  position: absolute;
  font-size: 0.625rem;
  width: 100%;
  left: 0;
  bottom: -23px;
  color: ${palette.text};
  text-align: center;
  color: ${({ captionColor }) => (captionColor === 'white' ? setColor('white') : setColor('greyText'))};
`;
